/**
 * Audio Element Schema
 */

import type {
    ElementSchema,
    MediaFieldSchema,
    TextFieldSchema,
    BooleanFieldSchema,
} from '@ai-content-hub/content-kit';

export const defaultAudioElementI18n = {
    en: {
        uploadAudio: 'Upload audio',
        play: 'Play',
        pause: 'Pause',
        audioSource: 'Audio source',
        audioTitlePlaceholder: 'Audio title...',
        playbackOptions: 'Playback options',
        autoplay: 'Autoplay',
        loop: 'Loop',
        showControls: 'Controls',
    },
    vi: {
        uploadAudio: 'Tải âm thanh lên',
        play: 'Phát',
        pause: 'Tạm dừng',
        audioSource: 'Nguồn âm thanh',
        audioTitlePlaceholder: 'Tiêu đề âm thanh...',
        playbackOptions: 'Tùy chọn phát',
        autoplay: 'Tự động phát',
        loop: 'Lặp lại',
        showControls: 'Điều khiển',
    },
};

export interface AudioElementData {
    src: string;
    title: string;
    autoplay: boolean;
    loop: boolean;
    showControls: boolean;
}

export const audioElementSchema: ElementSchema<AudioElementData> = {
    type: 'element-audio',
    title: 'Audio',
    description: 'Audio player with playback controls',
    version: '1.0.0',
    category: 'media',
    icon: 'Volume2',
    tags: ['audio', 'media', 'sound', 'music', 'podcast'],
    fields: [
        {
            name: 'src',
            type: 'media',
            label: 'Audio File',
            description: 'Upload or enter audio URL',
            required: true,
            mediaType: 'audio',
            accept: ['audio/*'],
        } as MediaFieldSchema,
        {
            name: 'title',
            type: 'text',
            label: 'Title',
            description: 'Audio title for accessibility',
            placeholder: 'Audio title...',
        } as TextFieldSchema,
        {
            name: 'autoplay',
            type: 'boolean',
            label: 'Autoplay',
            description: 'Start playing automatically',
            defaultValue: false,
        } as BooleanFieldSchema,
        {
            name: 'loop',
            type: 'boolean',
            label: 'Loop',
            description: 'Repeat when finished',
            defaultValue: false,
        } as BooleanFieldSchema,
        {
            name: 'showControls',
            type: 'boolean',
            label: 'Show Controls',
            description: 'Display playback controls',
            defaultValue: true,
        } as BooleanFieldSchema,
    ],
    defaultData: {
        src: '',
        title: '',
        autoplay: false,
        loop: false,
        showControls: true,
    },
    i18n: defaultAudioElementI18n,
};
